const info = {
    company: '云积分',
    miniappName: '京东大促搭配购',
    logo: '//enbrands-2.oss-cn-shanghai.aliyuncs.com/user/35f4200ac73fb44564001e309538dc7b.png'
};

const menu = [{
    name: '设置向导',
    key: 'setting',
    title: '设置向导',
},
{
    name: '活动管理',
    key: 'manager',
    title: '活动管理',
},
{
    name: '操作日志',
    key: 'log',
    title: '操作记录',
}
];


export default {
    info,
    menu,
}
